import DashboardAPI from './dashboard.api'

export default DashboardAPI
